export default "/img/tire.png";